module.exports = __webpack_public_path__ + "img/kit.698beb28.svg";